import { AHQueryHandlerError, Box } from "arkh";
import React from "react";

export function WidgetErrorFallback({
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) {
  return (
    <Box style={{ flex: 1 }} color="surface">
      <AHQueryHandlerError isLoading={false} onPress={resetErrorBoundary} />
    </Box>
  );
}
